module.exports = __webpack_public_path__ + "img/joias.9a18f162.png";